/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux';
import { RootState } from '../configureStore';
import { Party } from '../../data/types';

export type PartyState = {
    parties: Party[],
}

export const usePartyState = () => {
    const partyState = useSelector((state: RootState | any) => state.parties as PartyState);
    return partyState;
}

// Define the initial state using that type
const initialState: PartyState = {
    parties: [],
}

export const partySlice = createSlice({
    name: 'parties',
    initialState: initialState,
    reducers: {
        setPartiesAction: (state, action: PayloadAction<Party[]>) => {
            state.parties = action.payload;
        },
        addOrReplacePartyAction: (state, action: PayloadAction<Party>) => {
            const existingIndex = state.parties.findIndex((party: Party) => !!party && party.partyId === action.payload.partyId);
                if (existingIndex >= 0) {
                state.parties[existingIndex] = action.payload;
            } else {
                state.parties.push(action.payload);
            }
        },
        deletePartyAction: (state, action: PayloadAction<string>) => {
            state.parties = state.parties.filter((x) => x.partyId !== action.payload);
        },
        deletePartiesAction: (state, action: PayloadAction<string[]>) => {
            state.parties = state.parties.filter((x) => x.partyId && !action.payload.includes(x.partyId));
        },
    }
})

export const { addOrReplacePartyAction, setPartiesAction, deletePartyAction, deletePartiesAction } = partySlice.actions;

export default partySlice.reducer;